import { FetchResult } from "@apollo/client";

import { publishNodeInput, PublishNodeMutation } from "../../API";
import { IDeviceTableRow } from "../../pages/devices/hooks/useDeviceTableRows";
import { extractDeviceNameFromId } from "../utils/getEntityName";
import { buildMqttPublishHelpers } from "./mqttPublish";

export const captureLiveImage = async (
  deviceDetail: IDeviceTableRow,
  publishNode: (
    args: publishNodeInput
  ) => Promise<
    FetchResult<
      PublishNodeMutation,
      Record<string, string>,
      Record<string, string>
    >
  >
): Promise<void> => {
  const { extractedDeviceName } = extractDeviceNameFromId(deviceDetail?.rowId);

  const { requestDeviceImage } = buildMqttPublishHelpers(publishNode);

  await requestDeviceImage({
    deviceId: extractedDeviceName,
    nodeId: deviceDetail?.node.id ?? "",
    s3Key: deviceDetail?.deviceData?.recentFrame ?? undefined,
    footer: "TRUE",
    ack: deviceDetail?.node.id,
    successMessage: "A new live image is requested",
    errorMessage: "Something went wrong, a new live image isn't captured",
  });
};
